export default __webpack_public_path__ + "static/media/pattern-fan1.8c24bf74.jpg";